import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/RegisterTable.css';
import axios from "axios";
import { API } from "../../../services/api";
import Alert from "../../../components/alert";
// import SelectServer from "./selectserver";
import PosOrder from "./create/posorder";
import Payment from "./create/payment";
import SelectSugar from "./create/selectSugar";
import { AlertContext, UserContext } from "../../../App";

import posicon from '../../../img/icon/pos/point-of-service.png';
import exiticon from '../../../img/icon/mainMenu/exit.png';

axios.defaults.baseURL = API;

const POSContent = createContext();


function POS() {

const {showAlert, setShowAlert, errorMessage, setErrorMessage} = useContext(AlertContext);
const {userID, LocationID, LocationName, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);

  const [QueueID, setQueueID] = useState([]);
  const [QueueNumber, setQueueNumber] = useState([]);
  const [subTotal, setSubTotal] = useState([]);
  const [NetTotal, setNetTotal] = useState([]);
  const [NewNetTotal, setNewNetTotal] = useState(0);
  const [Tax, setTax] = useState(0);
  const [PaymentTypeList, setPaymentTypeList] = useState([]);
  const [CurrencyList, setCurrencyList] = useState([]);
  const [DiscountList, setDiscountList] = useState([]);
  const [TempOrder, setTempOrder] = useState([]);
  const [ImgUrl, setImgUrl] = useState([]);

  const [ProductID, setProductID] = useState([]);
  const [qty, setqty] = useState([]);
  const [LaoName, setLaoName] = useState([]);
  const [EngName, setEngName] = useState([]);
  const [Retail_Price, setRetail_Price] = useState([]);
  const [ProductType, setProductType] = useState([]);

  const [show, setShow] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showSelectSugar, setShowSelectSugar] = useState(false);
  const [showPayment, setShowPayment] = useState(false);

    async function getQueueByLocationID() {
        var dateNow = new Date().toISOString().split('T')[0]
        let token = localStorage.getItem("token");
        await axios.get(`/getQueueByLocationID/${LocationID}/${dateNow}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
            setQueueID(temOrder[0].QueueID);
            setQueueNumber(Number(temOrder[0].QueueNumber) + 1);
            } else {
            setQueueID('');
            setQueueNumber('1');
            }
        }).catch((err) => {
            setQueueID('');
            setQueueNumber('1');
            console.log(err);
        });
    }

    const handelclickQueue = () => {
        setShowOrder(true);
    };
    
    const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };

    async function getAllDiscount() {
        axios
          .get("/getAllDiscount")
          .then((response) => {
            let Data = response?.data;
            setDiscountList(Data);
          })
          .catch((error) => {
            console.log(error);
        });
      }
    
    useEffect(() => {
        let paymentData = localStorage.getItem("paymentTypeData");
        if (paymentData) {
            let payment = JSON.parse(paymentData);
            setPaymentTypeList(payment);
        }
        let currencyData = localStorage.getItem("currencyData");
        if (currencyData) {
            let currency = JSON.parse(currencyData);
            setCurrencyList(currency);
        }
        getQueueByLocationID();
        getAllDiscount();
}, []);

  return (
    <POSContent.Provider value={{LocationID, LocationName, PaymentTypeList, QueueID, setQueueID, QueueNumber, setQueueNumber,
    TempOrder, setTempOrder, CurrencyList, DiscountList, show, setShow, showPayment, setShowPayment, LaoName, setLaoName,
    ProductID, setProductID, qty, setqty, Retail_Price, setRetail_Price, EngName, setEngName, ProductType, setProductType,
    showOrder, setShowOrder, subTotal, setSubTotal, NetTotal, setNetTotal, NewNetTotal, setNewNetTotal, showSelectSugar, setShowSelectSugar,ImgUrl, setImgUrl,
    Tax, setTax, showAlert, setShowAlert, errorMessage, setErrorMessage}}>
      <div className="tableFormContent" style={{ display: showForm ? 'flex' : 'none' }}>
        <Alert/> 
        <PosOrder show={showOrder}/>
        <Payment show={showPayment}/>
        <SelectSugar show={showSelectSugar}/>
            
            <div className="tableContent">
                <div className="header">
                    <p>Manee Arabica Coffee</p>
                </div>
                <div className="qcontent">
                    <div className="tableItem" onClick={() => handelclickQueue()}>
                        <div className="imgIcon">
                            <img src={posicon} className="iconimg" />
                        </div>
                        <div className="name">
                            <p>ເລກຄິວ: {QueueNumber}</p>
                        </div>
                    </div>

                    <div className="tableItem" onClick={() => handleclickBack()}>
                        <div className="imgIcon">
                            <img src={exiticon} className="iconimg" />
                        </div>
                        <div className="name">
                            <p>BACK</p>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    </POSContent.Provider>
  );
};

export {POSContent};
export default POS;
